import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { generateUrl } from 'utils/helpers';
import { apiLoaderQuery } from 'store/query';

const tagType = 'Species Bitwerx';

export const speciesBitwerxApi = createApi({
  tagTypes: [tagType],
  baseQuery: apiLoaderQuery,
  reducerPath: 'speciesBitwerxApi',
  endpoints: (build) => ({
    list: build.query<any[], any>({
      providesTags: () => [tagType],
      transformResponse: (response: any) => response.data.species,
      query: (data: any) => ({
        method: 'get',
        url: generateUrl(URL.GET_BITWERX_SPECIES_MASTER_LIST, { id: data.id }),
      }),
    }),
  }),
});

export const { useListQuery } = speciesBitwerxApi;
